/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
import './fontAwesome/index.js';

// Global event bus
import './events';


// Import the plugin here
import {
  Auth0Plugin
} from "./auth/authService";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,

  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl ?
      appState.targetUrl :
      window.location.pathname
    );
  }
});

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// axios
import api from './api'
Vue.prototype.$http = api
import Manager from './api/Manager';
Vue.prototype.$api = new Manager();

// API Calls
import './http/requests'

// Theme Configurations
import '../themeConfig.js'


// ACL
// import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
// This will need to be discussed as it will probably break the whole validation
// process for the site. It is required as vueFormGenerator has a prop of the same
// name while not offering the ability to change it's name
// https://github.com/vue-generators/vue-form-generator/issues/657
Vue.use(VeeValidate, {
  errorBagName: 'vErrors',
  fieldsBagName: 'vFields'
});

// AG-Grid
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(process.env.VUE_APP_AG_GRID_API_KEY);


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'YOUR_KEY',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Vuejs - Vue wrapper for hammerjs
import {
  VueHammer
} from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Pikaday from 'pikaday/pikaday';
import 'pikaday/css/pikaday.css';
window.Pikaday = Pikaday;

Vue.component('multiselect', Multiselect)

import VueElementLoading from 'vue-element-loading'

Vue.component('VueElementLoading', VueElementLoading)

import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import validators, {
  resources
} from './validation/Vfg/resources';

VueFormGenerator.validators = Object.assign(
  VueFormGenerator.validators,
  validators,
);
VueFormGenerator.validators.resources = Object.assign(
  VueFormGenerator.validators.resources,
  resources,
);

Vue.use(VueFormGenerator)

import VfgFieldArray from 'vfg-field-array';
import VfgFieldObject from 'vfg-field-object';
import fieldVsCheckbox from '@/components/form/fields/fieldVsCheckbox';
import fieldButton from '@/components/form/fields/fieldButton';
import fieldAwesomeButton from '@/components/form/fields/fieldAwesomeButton';
import fieldPillButton from '@/components/form/fields/fieldPillButton';
Vue.component("fieldVsCheckbox", fieldVsCheckbox);
Vue.component("fieldButton", fieldButton);
Vue.component("fieldAwesomeButton", fieldAwesomeButton);
Vue.component("fieldPillButton", fieldPillButton);
Vue.use(VfgFieldArray);
Vue.use(VfgFieldObject);

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.devtools = process.env.VUE_APP_ENVIRONMENT === 'development'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  //acl,
  render: h => h(App)
}).$mount('#app')